import queryString from "qs"
import swal from "sweetalert2"
import shop from "shop/shop"
import settingStore from "stores/settingStore"
import categoryStore from "stores/categoryStore"
import $fetch from "sdk/$fetch"

// URL-Parameter, mit dem ein Link den OrderMode vorgibt, z.B. ...&orderMode=vororder
export const ORDER_MODE_PARAM = "orderMode"

// Zwischenseite für eingeloggte Nutzer: zeigt den Wechsel-Dialog und leitet dann zum Ziel weiter
export const ORDER_MODE_SWITCH_PATH = "/ordermode/"

const MODE_ALIASES = {
  sofort        : "MODE_AVAILABLE",
  sofortorder   : "MODE_AVAILABLE",
  available     : "MODE_AVAILABLE",
  mode_available: "MODE_AVAILABLE",
  vororder      : "MODE_PREORDER",
  preorder      : "MODE_PREORDER",
  mode_preorder : "MODE_PREORDER",
}

export function parseOrderMode( value ) {
  if ( !value || typeof value !== "string" ) return null
  return MODE_ALIASES[ value.toLowerCase() ] || null
}

// Zerlegt eine Ziel-URL in die URL ohne orderMode-Parameter und den gewünschten Modus
export function extractOrderMode( url ) {
  if ( !url ) return { url, mode: null }
  const [ pathname, search = "" ] = url.split( "?" )
  const query = queryString.parse( search )
  if ( !(ORDER_MODE_PARAM in query) ) return { url, mode: null }

  const mode = parseOrderMode( query[ ORDER_MODE_PARAM ] )
  delete query[ ORDER_MODE_PARAM ]
  const rest = queryString.stringify( query )
  return { url: rest ? `${pathname}?${rest}` : pathname, mode }
}

export function buildOrderModeSwitchUrl( mode, target ) {
  return `${ORDER_MODE_SWITCH_PATH}?${queryString.stringify( { mode, to: target } )}`
}

// Beim Seitenaufruf: Links mit ?orderMode=... umschreiben, bevor der Router startet.
// So wird die Zielseite erst nach der Modusprüfung (Zwischenseite) geladen.
export function rewriteInitialOrderModeUrl() {
  const { pathname, search, hash } = window.location
  if ( pathname.startsWith( "/login" ) || pathname.startsWith( ORDER_MODE_SWITCH_PATH ) ) return

  const rawTarget = `${pathname}${search}`
  const { url: target, mode } = extractOrderMode( rawTarget )
  if ( target === rawTarget ) return

  const next = mode ? buildOrderModeSwitchUrl( mode, `${target}${hash}` ) : `${target}${hash}`
  window.history.replaceState( window.history.state, "", next )
}

// Zeigt den "Wechsel bestätigen"-Dialog wie auf /home/. Resolved true, wenn gewechselt werden darf.
export function confirmOrderModeChange( mode ) {
  const oldMode = settingStore.get( "orderMode" )
  if ( !oldMode || mode === oldMode ) return Promise.resolve( true )

  return swal.fire( {
    type             : "info",
    title            : translate( "Wechsel bestätigen" ),
    text             : translate( "confirm_change" ),
    reverseButtons   : true,
    showCancelButton : true,
    confirmButtonText: translate( "Weiter" ),
    cancelButtonText : translate( "Zurück" ),
    backdrop         : "#fff",
    customClass      : "order-mode-popup",
  } )
    .then( ( { value } ) => {
      if ( value ) shop.cart.clear()
      return !!value
    } )
}

export function applyOrderMode( mode ) {
  $fetch.clear()
  console.log( "SET MODE", mode )
  settingStore.set( "orderMode", mode )
  categoryStore.updateCategories()
  shop.cart.setExtra( "preorder", mode === "MODE_PREORDER" )
}



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/shop/orderMode.js